import {ISocketState,IJobSocketDetailsActionTypes,IJobSocketActionCreator} from 'models/IJobSocketState';

const initialState:ISocketState[] = []

const reducer = (state = initialState, { type, payload }: IJobSocketActionCreator) => {
    switch (type) {
      case IJobSocketDetailsActionTypes.FETCH_JOB_SOCKET_DETAILS_REQUEST:
        return {
          ...state,
          data:[],
        }
      case IJobSocketDetailsActionTypes.FETCH_JOB_SOCKET_DETAILS_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;